<div class="col-md py-2 d-flex justify-content-center">
    <div class="row">
        <div class="col">
            <a href="http://www.sgs.com/certifiedclients" target="_blank"><img src="assets/images/pages/iso9001.jpg" width="50" ></a>
        </div>
        <div class="col">
            <a href="http://www.sgs.com/certifiedclients" target="_blank"><img src="assets/images/pages/iso14001.jpg" width="50" ></a>
        </div>
    </div>
</div>